// extracted by mini-css-extract-plugin
export default {"formInfo":"BillModal_formInfo__u0IQO","medicalCard":"BillModal_medicalCard__imi+P"};